export const getInitialState = () => {
  return {
    lead: null,
    leadFormConfig: {},
    listLeads: [],
    leadNotes: { total: 0, value: [] },
    isSearching: false,
    listWorkflowStates: null,
    listWorkflowStatesSelected: [],
    listWorkflowStatesSelectedTelephony: [],
    GET_LIST_PSL_AGENT_SELECTED: [],
    listWorkflowStatesSelectedOnline: [],
    leadType: 'Telephony',
    listPslAgent: null,
    listPslAgentSelected: [],
    history: null,
    showHistoryDetail: false,
    historyDetail: null,
    coverTypes: [],
    pslAgents: [],
    callOutComeLists: [],
    nextWorkflowStateList: [],
    listQuote: [],
    noIntroducerCode: false,
    listPossibleDuplicateLeads: [],
    embeddedJourneyYourDetailsForm: {
      title: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      findProperty: null,
      mortgageCategoryId: null,
      email: '',
      phoneNumber: '',
      preferredContactMethodCode: 'Email'
    },
    embeddedJourneyResponseData: null,
    privacyUrl: null
  };
};
